import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Rocket } from "lucide-react";

const PLAN_INFO = { starter: ["Starter", "3 properties", "£7.99/mo"], growth: ["Growth", "15 properties", "£14.99/mo"], pro: ["Pro", "50 properties", "£29.99/mo"] };

export default function UpgradeDialog({ info, onClose }) {
  const nav = useNavigate();
  if (!info) return null;
  const next = info.upgrade_to ? PLAN_INFO[info.upgrade_to] : null;
  return (
    <Dialog open={!!info} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-card max-w-md" data-testid="upgrade-dialog">
        <DialogHeader><DialogTitle className="font-heading flex items-center gap-2"><Rocket size={18} className="text-emerald-brand" /> Room for one more?</DialogTitle></DialogHeader>
        <p className="text-sm" data-testid="upgrade-message">You're using <b>{info.used} of {info.limit}</b> properties on the <span className="capitalize">{info.plan}</span> plan.</p>
        {next ? (
          <div className="mt-2 p-4 rounded-xl border-2 border-emerald-brand bg-emerald-50/50">
            <div className="font-semibold">{next[0]} — {next[1]}</div>
            <div className="text-sm text-muted-foreground">{next[2]} · cancel anytime · existing trial days carry over</div>
          </div>
        ) : <p className="text-sm text-muted-foreground mt-2">You're on our largest plan — get in touch for a portfolio quote.</p>}
        <div className="mt-3 flex gap-2">
          {next && <button data-testid="upgrade-now" onClick={() => nav(`/settings?upgrade=${info.upgrade_to}`)} className="flex-1 min-h-[44px] rounded-xl bg-emerald-brand hover:bg-emerald-deep text-white font-semibold">Upgrade to {next[0]}</button>}
          <button data-testid="upgrade-later" onClick={onClose} className="min-h-[44px] px-4 rounded-xl border border-border">Not now</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
